module.exports = __webpack_public_path__ + "img/cart.7aea2239.svg";